module.exports = __webpack_public_path__ + "img/mobileOperators.57bcedaf.png";